export default {
  reservations: 'Reserveringen',
  activated: 'Geactiveerd',
  deactivated: 'Gedeactiveerd',
  reservations_deactivated: 'Reserveringen zijn gedeactiveerd.',
  tabs: {
    general: 'Algemeen',
    information: 'Informatie',
  },
  sections: {
    notifications_confirmation: 'Meldingen & Bevestiging',
    notifications_confirmation_description: 'Hoe gasten reserveren en hoe u meldingen ontvangt.',
    who_can_book: 'Wie kan reserveren',
    who_can_book_description: 'Groottebeperkingen voor online reserveringen.',
    when_how_bookings_work: 'Wanneer & hoe reserveringen werken',
    when_how_bookings_work_description: 'Timing-, duur- en capaciteitsregels die bepalen welke tijdsloten gasten zien.',
  },
  google: {
    label: 'Reserveringen weergeven op Google',
  },
  storefront: {
    label: 'Reserveringen weergeven in de winkel',
  },
  auto_confirm: {
    label: 'Reserveringen automatisch bevestigen',
  },
  email: {
    label: 'E-mail voor inkomende reserveringen',
    add: 'E-mail toevoegen',
    placeholder: 'E-mailadres invoeren',
    required: 'Voeg minstens één e-mailadres toe om nieuwe reserveringen te ontvangen.',
    invalid: 'Voer een geldig e-mailadres in.',
  },
  has_whatsapp_phone_number: {
    label: 'Meldingen verzenden via WhatsApp',
  },
  whatsapp_phone_number: {
    label: 'WhatsApp-nummer',
    add: 'Telefoonnummer toevoegen',
  },
  party_size: {
    label: 'Toegestaan gezelschapsgrootte per reservering',
    min_label: 'Min',
    max_label: 'Max',
    to: 'tot',
    guests: 'gasten',
    helper:
      'Hoe klein of groot een reservering kan zijn. Een gast kan alleen reserveren voor een aantal personen binnen dit bereik.',
    warning:
      'Google accepteert alleen reserveringen voor 2–16 gasten. Reserveringen buiten dit bereik werken nog steeds in uw winkel, maar worden niet weergegeven op Google.',
    warning_min: 'Google raadt een minimum van 2 gasten aan voor reserveringen.',
    warning_max: 'Google raadt een maximum van 16 gasten aan voor reserveringen.',
    min_note: 'Google biedt geen reserveringen aan voor gezelschappen kleiner dan {{count}}.',
  },
  time_slot: {
    label: 'Reserveringsinterval',
    helper: 'Gasten kunnen reserveren in stappen van dit aantal minuten.',
    extra: 'bijv. {{example}}',
  },
  reservation_gap: {
    label: 'Reserveringsdeadline voor sluitingstijd',
    helper: 'Het laatste tijdstip waarop een gast een reservering kan starten, teruggeteld vanaf uw sluitingstijd.',
    helper_link: 'Bekijk uw reserveringsuren',
    extra: 'bijv. u sluit om 22:00, deadline {{example}} min → laatste boekbare starttijd is {{example}}',
  },
  reservation_notice_period: {
    label: 'Minimale vooraanmelding',
    helper: 'Het vroegste tijdstip waarop een gast kan reserveren vóór aankomsttijd.',
    extra: 'bijv. reserveer vóór {{example}} voor aankomst om 18:00',
  },
  opening_times: {
    label: 'Openingstijden',
  },
  total_seats: {
    label: 'Totale gastcapaciteit',
    helper:
      'Het maximale aantal gasten (niet tafels) dat tegelijkertijd kan worden geplaatst. Tel individuele stoelen — bijv. 5 tafels van 4 = 20.',
  },
  capacity_explainer: {
    title: 'Hoe capaciteit werkt',
    body: 'Dit is het aantal gasten dat u tegelijk kunt plaatsen. Elke reservering houdt zijn stoelen bezet voor de duur ervan en geeft ze daarna vrij voor de volgende gasten. Het systeem houdt genoeg ruimte voor iedereen die geboekt heeft, zodat u nooit overbezet bent.',
    body_example:
      'Voorbeeld: met 20 stoelen kunt u een reservering voor 12 gasten om 19:00 en een reservering voor 10 gasten om 21:00 aannemen, omdat de stoelen van het eerste gezelschap vrijkomen voordat het volgende aankomt.',
  },
  note: {
    label: 'Opmerking',
  },
  grace_period: {
    label: 'Respijtperiode',
    helper: 'Hoe lang een tafel wordt vastgehouden na de starttijd van de reservering.',
    tooltip:
      'Extra buffer na de duur van een reservering voordat de tafel opnieuw wordt aangeboden (bijv. om de tafel schoon te maken en opnieuw in te stellen).',
    extra: 'bijv. vastgehouden tot {{example}} voor een reservering om 18:00',
    placeholder: 'Respijtperiode invoeren',
  },
  information: {
    rules: {
      label: 'Uw tafel wordt gereserveerd voor:',
      add: 'Toevoegen',
    },
  },
  reservation_duration: {
    label: 'Reserveringsduur',
    helper: 'Hoe lang elke tafel per reservering wordt vastgehouden.',
    tooltip:
      'Hoe lang een tafel per reservering wordt vastgehouden. Dit wordt gebruikt om te berekenen wanneer een tafel weer vrij is voor de volgende gast.',
    extra: 'bijv. 18:00 – {{example}}',
    minutes: '{{ count }} Minuten',
    hour_one: '{{ count }} Uur',
    hour_other: '{{ count }} Uren',
  },
  buttons: {
    save: 'Opslaan',
    activate: 'Activeren',
    deactivate: 'Deactiveren',
  },
  success_messages: {
    updated: 'Update geslaagd',
    saving_successful:
      'Update geslaagd. Houd er rekening mee dat Google tot 24 uur nodig kan hebben om de wijzigingen door te voeren.',
  },
  error_messages: {
    invalid_phone_number: 'Ongeldig telefoonnummer',
    saving_unsuccessful: 'Fout bij opslaan. Probeer het opnieuw.',
    enter_correct_email: 'Voer een geldig e-mailadres in.',
  },
};
